import { useAtom } from 'jotai';

import {
  SCREENER_FACILITY_VIEW_KIND,
  useScreenerFacilityView
} from '@/hooks/facility-selection/useScreenerFacilityView';
import {
  selectedFacilityIdAtom,
  useFacilitiesQuery
} from '@/hooks/useFacilitiesQuery';

export function useHasFaxIntegration(): {
  isLoading: boolean;
  hasFaxIntegration: boolean;
} {
  const [currentFacilityId] = useAtom(selectedFacilityIdAtom);
  const { view } = useScreenerFacilityView();
  const isAllFacilities =
    view.kind === SCREENER_FACILITY_VIEW_KIND.AllFacilities;
  const { useFindOne, useFindAll } = useFacilitiesQuery();

  const { data: facility, isLoading: isLoadingSingle } = useFindOne(
    isAllFacilities ? null : currentFacilityId
  );

  const { data: facilities, isLoading: isLoadingAll } = useFindAll({
    enabled: isAllFacilities
  });

  const hasFaxIntegration = isAllFacilities
    ? Boolean(
        facilities?.some(
          (f) => f.has_fax_integration && f.facility_type === view.facilityType
        )
      )
    : Boolean(facility?.has_fax_integration);

  return {
    hasFaxIntegration,
    isLoading: isAllFacilities ? isLoadingAll : isLoadingSingle
  };
}
